/* eslint-disable mocha/prefer-arrow-callback -- We're using them here to give our functions meaningful names. */
import { useDispatch } from 'react-redux';
import NavigationStore from '../../redux/navigation';
import { useOnMount } from '../../hooks';

const navProps = {
  //  Setting this informs the Navigation component that it
  //  shouldn't render with its usual 3px border-bottom.
  shouldUseCallToAction: true,
};

/**
 * Hook for managing the old NavState when using
 * a call-to-action component. We need to tell the
 * subnav that we're using the CTA so that it renders
 * without its border-bottom.
 */
const useCallToAction = () => {
  const dispatch = useDispatch();

  //  When the page loads, tell the Nav that we don't want to
  //  render a Subnav and that we're using the CTA.
  useOnMount(
    function onMount() {
      return dispatch(NavigationStore.actions.setNavState({
        navProps,
        expand: null,
        subnav: null,
      }));
    },
    function onUnmount() {
      return dispatch(NavigationStore.actions.setNavState({
        //  We need to unset the
        navProps: {},
        expand: null,
        subnav: null,
      }));
    },
  );
};

export default useCallToAction;
